export default "__VITE_ASSET__174ac2d7__"